import AuthService from "./AuthService";
import ExperienceService from "./ExperienceService";
import TourService from "./TourService";
import EventService from "./EventService";
import ContestService from "./ContestService";
import OfferService from "./OfferService";
import VoucherService from "./VoucherService";
import StoriesService from "./StoriesService";
import FileService from "./FileService";
import UserService from "./UserService";
import ReferenceService from "./ReferenceService";
import ActivityService from "./ActivityService";
import ExperienceChatService from "./ExperienceMessageService";
import LoginSocialService from "./loginSocialService";
import UpdateContentStatus from "./BatchUpdateContentStatus";
import MomentService from "./MomentService";
import NewsService from "./NewsService";
import PlatformService from "./PlatformService";
import GroupService from "./GroupService";

const repository = {
  auth: new AuthService(),
  activity: new ActivityService(),
  expChat: new ExperienceChatService(),
  exp: new ExperienceService(),
  tour: new TourService(),
  file: new FileService(),
  ref: new ReferenceService(),
  user: new UserService(),
  event: new EventService(),
  contest: new ContestService(),
  offer: new OfferService(),
  voucher: new VoucherService(),
  story: new StoriesService(),
  moment: new MomentService(),
  socialLogin: new LoginSocialService(),
  statusContent: new UpdateContentStatus(),
  news: new NewsService(),
  platform: new PlatformService(),
  group: new GroupService(),
};

const install = (Vue) => {
  Vue.mixin({
    beforeCreate() {
      this.$repo = repository;
    },
  });
};

export default {
  install,
};
